/* eslint-disable no-multiple-empty-lines */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DateTimeService } from '../../services/date-time.service';
import { StorageService } from '../../services/storage.service';
import { UserInfoService } from '../../services/user-info.service';

@Component({
  selector: 'lib-guarantee-approval',
  templateUrl: './guarantee-approval.component.html'
})
export class GuaranteeApprovalComponent implements OnInit {

  public guaranteeApprovalGroup: FormGroup;
  public guaranteeStatusList: any[] = [];
  public rejectionReasonList: any[] = [];
  public formData:any = { 'variables': {} };
  public load = false;
  public showrejectionReason = false;
  public showRemarks = false;
  @Input() public defaultFormData: string[];
  @Output() public submitedFormData = new EventEmitter<FormData>();

  constructor(private formBuilder: FormBuilder, private dataTimeService: DateTimeService, private storage: StorageService, public userInfo: UserInfoService) { }

  ngOnInit():void {
    if (typeof this.defaultFormData === 'object') {
      this.onLoad(this.defaultFormData);
      this.load = true;
    }
  }

  onLoad(data:any):void {
    this.guaranteeApprovalGroup = this.formBuilder.group({
      guaranteeStatus: [null, [Validators.required]],
      rejectionReason: [null],
      remarks: [null]
    });

    const keys = Object.keys(data.rdmData);
    keys.forEach((key) => {
      if (key.indexOf('status') >= 0) {
        this.guaranteeStatusList = data.rdmData[key];
      } else if (key.indexOf('rejectionreason') >= 0) {
        this.rejectionReasonList = data.rdmData[key];
      }
    });
  }

  guaranteeStatusChange(value: string):void {
    const insStatus = this.guaranteeApprovalGroup.controls['guaranteeStatus'];
    const rejStatus = this.guaranteeApprovalGroup.controls['rejectionReason'];
    const appRemark = this.guaranteeApprovalGroup.controls['remarks'];
    if (value.includes('APP')) {
      this.showrejectionReason = false;
      insStatus.setValidators(Validators.required);
      rejStatus.clearValidators();
      appRemark.clearValidators();
    } else if (value.includes('REJ')) {
      this.showrejectionReason = true;
      rejStatus.setValidators([Validators.required]);
      appRemark.setValidators([Validators.required]);
      insStatus.clearValidators();
    } else {
      this.showrejectionReason = false;
      rejStatus.clearValidators();
      insStatus.clearValidators();
    }

  }



  onSubmit():void  {
    for (const i in this.guaranteeApprovalGroup.controls) {
      if(i in this.guaranteeApprovalGroup.controls){
        this.guaranteeApprovalGroup.controls[i].markAsDirty();
        this.guaranteeApprovalGroup.controls[i].updateValueAndValidity();
      }
    }

    if (this.guaranteeApprovalGroup.value.guaranteeStatus !== null) {
      this.formData.variables['status'] = { 'value': this.guaranteeApprovalGroup.value.guaranteeStatus };
      this.formData.variables['action'] = { 'value': this.guaranteeApprovalGroup.value.guaranteeStatus };

    }

    if (this.guaranteeApprovalGroup.value.rejectionReason !== null) {
      this.formData.variables['rejectionReasonCode'] = { 'value': this.guaranteeApprovalGroup.value.rejectionReason };
    }


    if (this.guaranteeApprovalGroup.value.remarks !== null) {
      this.formData.variables['reviewerRemarks'] = { 'value': this.guaranteeApprovalGroup.value.remarks };
    }

    this.formData.variables['modifiedBy'] = { 'value': this.userInfo.getUserName() };

    if (this.guaranteeApprovalGroup.valid) {
      this.submitedFormData.emit(this.formData);
    }

  }


}
